import './LogIn.css';

import React, {useState} from "react";
import {faUserSecret} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {LogInState} from "../types";
import {authService} from "../services/authService";
import {useAuth} from "../hooks/useAuth";
import Header from "shared/components/Header/Header";

enum RefreshTokenStatus{
    NotSent,
    WaitingForResponse,
    IncorrectDfsToken,
    NetworkError
}

const RefreshToken: React.FC = () => {
    const { setLoggedIn } = useAuth();

    const [dfs_access_token, setDfs_access_token] = useState<string>('');

    const [refreshTokenStatus, setRefreshTokenStatus] = useState<RefreshTokenStatus>(RefreshTokenStatus.NotSent);
    const [networkError, setNetworkError] = useState<number>(0);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setRefreshTokenStatus(RefreshTokenStatus.WaitingForResponse);
        authService.refreshToken(dfs_access_token.trim()).then(response => {
            if (response.errorCode){
                setNetworkError(response.errorCode);
                setRefreshTokenStatus(RefreshTokenStatus.NetworkError);
            } else if (!response.success) {
                setRefreshTokenStatus(RefreshTokenStatus.IncorrectDfsToken);
            } else {
                setLoggedIn(LogInState.LoggedIn);
            }
        });
    };
    
    return (
        <div className="login-page">
            <Header logOut={false} help={true} />
            <div className="login-form-area">
                <h2 className="subheading">Please, specify your VIPER access token!</h2>
                <div className="form-container">
                    <form className='form' onSubmit={handleSubmit}>
                        <label htmlFor="inputField"><FontAwesomeIcon icon={faUserSecret} className="form-icon"/>VIPER access token (Authorization header without "Basic "):</label>
                        <input type="text"
                               id="dfs_access_token"
                               value={dfs_access_token}
                               disabled={refreshTokenStatus === RefreshTokenStatus.WaitingForResponse}
                               onChange={(event) => {setDfs_access_token(event.target.value); setRefreshTokenStatus(RefreshTokenStatus.NotSent);}}
                        />
                        <p className="info-text-mini">
                            {refreshTokenStatus === RefreshTokenStatus.WaitingForResponse?
                                "Waiting for response..." : ""}
                        </p>
                        <p className="error-text-mini">
                            { refreshTokenStatus === RefreshTokenStatus.IncorrectDfsToken?
                                "Incorrect or expired token!":
                                refreshTokenStatus === RefreshTokenStatus.NetworkError?
                                    `Error: ${networkError}`: ""
                            }
                        </p>
                        <button className="button green-button" type="submit" disabled={dfs_access_token === "" || refreshTokenStatus === RefreshTokenStatus.WaitingForResponse}>Refresh Token</button>
                    </form>
                </div>
                <div className="filler"></div>
            </div>
        </div>
    );
};

export default RefreshToken;